import React, { useEffect, useState } from 'react';
// ════════════════════════════════════════════════════════
// PriceAnchorSection.tsx
// ════════════════════════════════════════════════════════

import { motion } from 'framer-motion';
import { Check, X, ChevronDown, CreditCard, Shield, Smartphone } from 'lucide-react';
const KIT_URL = 'https://digital-solvex-ar.myshopify.com/cart/48566694772993:1';
export function PriceAnchorSection() {
  const items = [{
    name: 'Blindaje Profesional ARCA 2026',
    price: '$79.900'
  }, {
    name: 'Excel Maestro Argentina',
    price: '$39.900'
  }, {
    name: 'Guía de Inversión Defensiva',
    price: '$29.900'
  }, {
    name: 'Kit de Respuesta ARCA',
    price: '$29.900'
  }, {
    name: 'Masterclass Ruta Freelancer Global',
    price: '$99.900'
  }];
  return <section className="bg-navy-dark py-16 md:py-24 px-4" data-id="element-539">
      <div className="max-w-2xl mx-auto" data-id="element-540">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.6
      }} data-id="element-541">
          <p className="text-xs font-bold text-teal tracking-widest uppercase mb-3 text-center" data-id="element-542">
            Resumen de inversión
          </p>
          <h2 className="font-display text-3xl md:text-4xl text-white text-center mb-10 leading-tight" data-id="element-543">
            Lo que recibís hoy
          </h2>

          <div className="bg-navy-mid rounded-2xl overflow-hidden border border-white/[0.07] mb-8" data-id="element-544">
            {items.map((item, i) => <div key={i} className="flex items-center justify-between px-6 py-4 border-b border-white/[0.05] last:border-0" data-id="element-545">
                <div className="flex items-center gap-3" data-id="element-546">
                  <span className="w-5 h-5 rounded-full bg-teal/15 flex items-center justify-center flex-shrink-0" data-id="element-547">
                    <Check className="w-3 h-3 text-teal" data-id="element-548" />
                  </span>
                  <span className="text-white/80 text-sm" data-id="element-549">{item.name}</span>
                </div>
                <span className="text-white/25 text-sm line-through flex-shrink-0 ml-4" data-id="element-550">
                  {item.price}
                </span>
              </div>)}
          </div>

          {/* Value summary */}
          <div className="text-center mb-8" data-id="element-551">
            <p className="text-white/35 text-base mb-1" data-id="element-552">
              Valor total real: <span className="line-through" data-id="element-553">$279.500</span>
            </p>
            <div className="w-full h-px bg-gradient-to-r from-transparent via-gold/35 to-transparent my-5" data-id="element-554" />
            <p className="text-white/55 text-base mb-2" data-id="element-555">Tu inversión hoy:</p>
            <div className="font-display text-7xl md:text-8xl gold-shine leading-none mb-4" data-id="element-556">
              $62.900
            </div>
            <div className="inline-flex items-center gap-2 bg-teal/10 border border-teal/25 rounded-full px-5 py-2" data-id="element-557">
              <span className="text-teal font-bold text-base" data-id="element-558">
                Ahorrás $216.600
              </span>
              <span className="text-teal/60 text-sm" data-id="element-559">— 77% de descuento</span>
            </div>
          </div>

          <a href={KIT_URL} className="btn-gold block text-center font-display text-xl px-8 py-5 rounded-xl no-underline mb-4" data-id="element-560">
            Quiero el Kit Completo — $62.900 →
          </a>

          {/* Mercado Pago trust row */}
          <div className="bg-white/[0.03] border border-white/[0.06] rounded-xl p-4" data-id="element-561">
            <p className="text-center text-white/35 text-xs uppercase tracking-wider mb-3 font-semibold" data-id="element-562">
              Pago 100% seguro con
            </p>
            <div className="flex items-center justify-center gap-3 flex-wrap" data-id="element-563">
              <div className="flex items-center gap-2 bg-[#009EE3]/15 border border-[#009EE3]/30 rounded-lg px-3 py-2" data-id="element-564">
                <div className="w-5 h-5 rounded-full bg-[#009EE3] flex items-center justify-center flex-shrink-0" data-id="element-565">
                  <CreditCard className="w-3 h-3 text-white" data-id="element-566" />
                </div>
                <span className="text-xs font-extrabold text-[#009EE3]" data-id="element-567">
                  Mercado Pago
                </span>
              </div>
              {['VISA', 'MASTERCARD', 'AMEX', 'DÉBITO', 'TRANSFERENCIA'].map(b => <span key={b} className="text-[10px] font-extrabold text-white/40 bg-white/[0.05] border border-white/[0.08] px-2.5 py-1.5 rounded" data-id="element-568">
                    {b}
                  </span>)}
            </div>
            <div className="flex items-center justify-center gap-2 mt-3" data-id="element-569">
              <Shield className="w-3.5 h-3.5 text-teal" data-id="element-570" />
              <span className="text-xs text-white/30" data-id="element-571">
                Transacción encriptada y protegida
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}
// ════════════════════════════════════════════════════════
// AgitationSection.tsx
// ════════════════════════════════════════════════════════
export function AgitationSection() {
  return <section className="bg-gray-warm py-16 md:py-24 px-4" data-id="element-572">
      <div className="max-w-5xl mx-auto" data-id="element-573">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-14" data-id="element-574">
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl text-navy-mid leading-tight max-w-3xl mx-auto" data-id="element-575">
            El problema no es que no trabajés duro.
            <br data-id="element-576" />
            <span className="text-gold" data-id="element-577">
              Es que nadie te enseñó a proteger lo que ganás.
            </span>
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-578">
          {/* Without kit */}
          <motion.div initial={{
          opacity: 0,
          x: -24
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="bg-white rounded-2xl p-8 border border-red-100 shadow-sm" data-id="element-579">
            <div className="flex items-center gap-3 mb-6" data-id="element-580">
              <div className="w-8 h-8 rounded-full bg-red-100 flex items-center justify-center" data-id="element-581">
                <X className="w-4 h-4 text-red-500" data-id="element-582" />
              </div>
              <span className="text-xs font-extrabold tracking-widest uppercase text-red-500" data-id="element-583">
                Sin el Kit
              </span>
            </div>
            {['Sin sistema → fin de mes, no sabés cuánto ganaste', 'Sin blindaje → ARCA detecta inconsistencias y notifica', 'Sin dolarización → la inflación destruye tu ahorro en pesos', 'Sin estructura → trabajás más pero no ganás en términos reales'].map((item, i) => <div key={i} className="flex gap-3 items-start mb-4" data-id="element-584">
                <div className="w-5 h-5 rounded-full bg-red-100 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-585">
                  <X className="w-3 h-3 text-red-500" data-id="element-586" />
                </div>
                <p className="text-gray-600 text-sm leading-relaxed" data-id="element-587">{item}</p>
              </div>)}
          </motion.div>

          {/* With kit */}
          <motion.div initial={{
          opacity: 0,
          x: 24
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-white rounded-2xl p-8 border border-teal/25 shadow-sm" data-id="element-588">
            <div className="flex items-center gap-3 mb-6" data-id="element-589">
              <div className="w-8 h-8 rounded-full bg-teal/10 flex items-center justify-center" data-id="element-590">
                <Check className="w-4 h-4 text-teal" data-id="element-591" />
              </div>
              <span className="text-xs font-extrabold tracking-widest uppercase text-teal" data-id="element-592">
                Con el Kit Blindaje
              </span>
            </div>
            {['Control total de tu dinero en tiempo real', 'Operás con tranquilidad porque todo está ordenado', 'Tu dinero crece mientras dormís con inversión defensiva', 'Cobrás en dólares reales cada mes desde Argentina'].map((item, i) => <div key={i} className="flex gap-3 items-start mb-4" data-id="element-593">
                <div className="w-5 h-5 rounded-full bg-teal/10 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-594">
                  <Check className="w-3 h-3 text-teal" data-id="element-595" />
                </div>
                <p className="text-gray-600 text-sm leading-relaxed" data-id="element-596">{item}</p>
              </div>)}
          </motion.div>
        </div>
      </div>
    </section>;
}
// ════════════════════════════════════════════════════════
// WhoIsItFor.tsx
// ════════════════════════════════════════════════════════
export function WhoIsItFor() {
  return <section className="bg-white py-16 md:py-24 px-4" data-id="element-597">
      <div className="max-w-5xl mx-auto" data-id="element-598">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-599">
          <h2 className="font-display text-3xl md:text-4xl text-navy-mid mb-3 leading-tight" data-id="element-600">
            ¿Este kit es para vos?
          </h2>
          <p className="text-gray-500" data-id="element-601">
            Diseñado específicamente para profesionales independientes
            argentinos
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-602">
          <motion.div initial={{
          opacity: 0,
          x: -22
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="bg-teal/[0.04] border border-teal/20 rounded-2xl p-8" data-id="element-603">
            <p className="text-xs font-extrabold tracking-widest uppercase text-teal mb-6" data-id="element-604">
              Sí, es para vos si...
            </p>
            {['Médico, odontólogo o profesional de la salud que factura por obras sociales', 'Abogado o contador con honorarios mixtos en pesos y dólares', 'Arquitecto o ingeniero independiente', 'Freelancer que quiere cobrar del exterior legalmente', 'Monotributista que quiere entender sus finanzas de una vez'].map((item, i) => <div key={i} className="flex gap-3 items-start mb-3" data-id="element-605">
                <div className="w-5 h-5 rounded-full bg-teal/15 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-606">
                  <Check className="w-3 h-3 text-teal" data-id="element-607" />
                </div>
                <p className="text-gray-700 text-sm leading-relaxed" data-id="element-608">{item}</p>
              </div>)}
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 22
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-red-50 border border-red-100 rounded-2xl p-8" data-id="element-609">
            <p className="text-xs font-extrabold tracking-widest uppercase text-red-500 mb-6" data-id="element-610">
              No es para vos si...
            </p>
            {['Buscás evadir impuestos (esto es 100% legal y transparente)', 'Ya tenés un sistema financiero impecable y contador de confianza', 'No estás dispuesto a implementar lo que aprendés'].map((item, i) => <div key={i} className="flex gap-3 items-start mb-3" data-id="element-611">
                <div className="w-5 h-5 rounded-full bg-red-100 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-612">
                  <X className="w-3 h-3 text-red-500" data-id="element-613" />
                </div>
                <p className="text-gray-700 text-sm leading-relaxed" data-id="element-614">{item}</p>
              </div>)}
          </motion.div>
        </div>
      </div>
    </section>;
}
// ════════════════════════════════════════════════════════
// FAQSection.tsx
// ════════════════════════════════════════════════════════
const faqs = [{
  q: '¿Cómo recibo los productos después de pagar?',
  a: 'De forma inmediata. En el momento en que se confirma tu pago, Mercado Pago redirige a la página de descarga con acceso a todos los archivos. También recibirás un email con los links de descarga.'
}, {
  q: '¿Los precios están en pesos argentinos?',
  a: 'Sí, todos los precios son en pesos argentinos (ARS) y el pago se procesa a través de Mercado Pago con tarjeta de crédito, débito o transferencia bancaria.'
}, {
  q: '¿Es contenido legal? ¿No es evasión?',
  a: '100% legal. Todo el contenido está basado en la normativa vigente de ARCA, BCRA y el sistema impositivo argentino. No enseñamos ni promovemos evasión — enseñamos a usar correctamente los instrumentos que el sistema permite.'
}, {
  q: '¿El contenido se actualiza?',
  a: 'Sí. Cuando hay cambios normativos relevantes actualizamos el material y los compradores reciben acceso a la versión nueva sin costo adicional.'
}, {
  q: '¿Puedo comprar solo un producto?',
  a: 'Sí, más abajo encontrás los tres productos principales disponibles por separado. Pero el Kit Completo es la opción más conveniente — obtenés los 5 productos por el precio de uno.'
}, {
  q: '¿Funciona para profesionales del interior del país?',
  a: 'Absolutamente. La normativa de ARCA, Monotributo y las estrategias de inversión aplican a nivel nacional.'
}, {
  q: '¿Necesito conocimientos de Excel o contabilidad?',
  a: 'No. El Excel Maestro fue diseñado para que solo completes las celdas en azul — el resto lo calcula automáticamente. Los eBooks están escritos en lenguaje claro, sin jerga técnica.'
}];
function FAQItem({
  faq,
  open,
  onToggle
}: {
  faq: {
    q: string;
    a: string;
  };
  open: boolean;
  onToggle: () => void;
}) {
  return <div className="border-b border-gray-200" data-id="element-615">
      <button onClick={onToggle} className="w-full flex items-center justify-between py-5 text-left gap-4 bg-transparent border-0 cursor-pointer" data-id="element-616">
        <span className="font-bold text-navy-mid text-base md:text-lg leading-snug" data-id="element-617">
          {faq.q}
        </span>
        <ChevronDown className={`w-5 h-5 text-navy-mid flex-shrink-0 transition-transform duration-200 ${open ? 'rotate-180' : ''}`} data-id="element-618" />
      </button>
      <motion.div initial={false} animate={{
      height: open ? 'auto' : 0,
      opacity: open ? 1 : 0
    }} transition={{
      duration: 0.22
    }} className="overflow-hidden" data-id="element-619">
        <p className="text-gray-600 text-sm leading-relaxed pb-5 pr-8" data-id="element-620">
          {faq.a}
        </p>
      </motion.div>
    </div>;
}
export function FAQSection() {
  const [open, setOpen] = useState<number | null>(null);
  return <section className="bg-gray-warm py-16 md:py-24 px-4" data-id="element-621">
      <div className="max-w-3xl mx-auto" data-id="element-622">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-623">
          <h2 className="font-display text-3xl md:text-4xl text-navy-mid leading-tight" data-id="element-624">
            Preguntas frecuentes
          </h2>
        </motion.div>
        <div className="bg-white rounded-2xl px-6 shadow-sm border border-gray-100" data-id="element-625">
          {faqs.map((faq, i) => <FAQItem key={i} faq={faq} open={open === i} onToggle={() => setOpen(open === i ? null : i)} data-id="element-626" />)}
        </div>
      </div>
    </section>;
}
// ════════════════════════════════════════════════════════
// FinalCTA.tsx
// ════════════════════════════════════════════════════════
function getEndTime(): number {
  const key = 'ds_ar_cd_end';
  const stored = localStorage.getItem(key);
  if (stored) {
    const v = parseInt(stored, 10);
    if (v > Date.now()) return v;
  }
  const end = Date.now() + 47 * 3600 * 1000;
  try {
    localStorage.setItem(key, end.toString());
  } catch {}
  return end;
}
export function FinalCTA() {
  const [t, setT] = useState({
    h: 47,
    m: 0,
    s: 0
  });
  useEffect(() => {
    const end = getEndTime();
    const tick = () => {
      const diff = Math.max(0, end - Date.now());
      setT({
        h: Math.floor(diff / 3600000),
        m: Math.floor(diff % 3600000 / 60000),
        s: Math.floor(diff % 60000 / 1000)
      });
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, []);
  const pad = (n: number) => String(n).padStart(2, '0');
  return <section className="bg-navy-mid dot-bg py-16 md:py-24 px-4" data-id="element-627">
      <div className="max-w-3xl mx-auto text-center" data-id="element-628">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.6
      }} data-id="element-629">
          <p className="text-xs font-bold text-teal tracking-widest uppercase mb-8" data-id="element-630">
            Precio de lanzamiento
          </p>

          {/* Countdown */}
          <div className="flex justify-center gap-4 mb-12" data-id="element-631">
            {[{
            v: t.h,
            l: 'HORAS'
          }, {
            v: t.m,
            l: 'MIN'
          }, {
            v: t.s,
            l: 'SEG'
          }].map(({
            v,
            l
          }) => <div key={l} className="text-center" data-id="element-632">
                <div className="w-20 h-20 md:w-24 md:h-24 bg-white/[0.06] border border-gold/20 rounded-xl flex items-center justify-center mb-2" data-id="element-633">
                  <span className="font-display text-3xl md:text-4xl gold-shine" data-id="element-634">
                    {pad(v)}
                  </span>
                </div>
                <span className="text-[10px] text-white/30 tracking-[0.18em] uppercase" data-id="element-635">
                  {l}
                </span>
              </div>)}
          </div>

          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl text-white leading-tight mb-5" data-id="element-636">
            Este precio de lanzamiento
            <br data-id="element-637" />
            <span className="gold-shine" data-id="element-638">no dura para siempre</span>
          </h2>

          <p className="text-white/55 text-lg leading-relaxed mb-10 max-w-xl mx-auto" data-id="element-639">
            Estás a un clic de tener el sistema completo para blindar tu
            patrimonio, organizar tus finanzas y cobrar en dólares — todo por
            $62.900.
          </p>

          <a href={KIT_URL} className="btn-gold block font-display text-xl md:text-2xl py-6 px-10 rounded-xl no-underline mb-5" data-id="element-640">
            Sí, quiero el Kit Completo ahora →
          </a>

          <p className="text-white/30 text-sm" data-id="element-641">
            Acceso inmediato &middot; Mercado Pago seguro &middot; Descarga
            instantánea
          </p>
        </motion.div>
      </div>
    </section>;
}
// ════════════════════════════════════════════════════════
// Footer.tsx
// ════════════════════════════════════════════════════════
export function Footer() {
  return <footer className="bg-navy-dark border-t border-white/[0.06] py-10 px-4" data-id="element-642">
      <div className="max-w-6xl mx-auto" data-id="element-643">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6 mb-6" data-id="element-644">
          <span className="font-display text-2xl text-white" data-id="element-645">
            Digital <span className="text-gold" data-id="element-646">Solvex</span>
          </span>
          <div className="flex flex-wrap gap-6 text-sm" data-id="element-647">
            {['Política de privacidad', 'Términos y condiciones', 'Política de reembolsos'].map(link => <a key={link} href="#" className="text-white/35 hover:text-white transition-colors no-underline" data-id="element-648">
                {link}
              </a>)}
          </div>
        </div>
        <div className="border-t border-white/[0.05] pt-6 text-center" data-id="element-649">
          <p className="text-white/25 text-xs mb-1" data-id="element-650">
            © 2026 Digital Solvex · argentina.digitalsolvex.shop
          </p>
          <p className="text-white/15 text-xs" data-id="element-651">
            Este sitio no está afiliado ni patrocinado por ARCA o ningún
            organismo gubernamental argentino.
          </p>
        </div>
      </div>
    </footer>;
}